export default __webpack_public_path__ + "static/media/about-team-tim-lai.ce6b2f2d.png";